unit View.Nfse.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  UHelperServer;

type
  TFViewNfseEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbnumero: TLabel;
    ednumero: TDBEdit;
    lbnfse_transmitida: TLabel;
    lbnfse_consolidada: TLabel;
    lbnfse_cancelada: TLabel;
    lbchave_acesso: TLabel;
    edchave_acesso: TDBEdit;
    lbdata_emissao: TLabel;
    eddata_emissao: TDBEdit;
    lbprotocolo: TLabel;
    edprotocolo: TDBEdit;
    lbrps_numero: TLabel;
    edrps_numero: TDBEdit;
    lbnumero_lote: TLabel;
    ednumero_lote: TDBEdit;
    lbserie: TLabel;
    edserie: TDBEdit;
    lbdata_competencia: TLabel;
    eddata_competencia: TDBEdit;
    lberro_transmissao: TLabel;
    ederro_transmissao: TDBEdit;
    lbnfse_erro_provedor: TLabel;
    lbobs: TLabel;
    edobs: TDBEdit;
    lbdata_cancelamento: TLabel;
    eddata_cancelamento: TDBEdit;
    lbjustificativa_cancelamento: TLabel;
    edjustificativa_cancelamento: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientNfseGet: TXDataWebClient;
    NfseDataset: TXDataWebDataSet;
    NfseDatasetid: TIntegerField;
    NfseDatasetaliado_id: TIntegerField;
    NfseDatasetdata_base_id: TIntegerField;
    NfseDatasetnumero: TIntegerField;
    NfseDatasetnfse_transmitida: TBooleanField;
    NfseDatasetnfse_consolidada: TBooleanField;
    NfseDatasetnfse_cancelada: TBooleanField;
    NfseDatasetnfse_cod_verificacao: TStringField;
    NfseDatasetchave_acesso: TStringField;
    NfseDatasetdata_emissao: TDateTimeField;
    NfseDatasetprotocolo: TStringField;
    NfseDatasetrps_numero: TIntegerField;
    NfseDatasetnumero_lote: TIntegerField;
    NfseDatasetserie: TStringField;
    NfseDatasetnfse_xml_s3: TStringField;
    NfseDatasetanexo_sincronizado: TIntegerField;
    NfseDatasetdata_competencia: TDateTimeField;
    NfseDataseterro_transmissao: TStringField;
    NfseDatasetnfse_erro_provedor: TBooleanField;
    NfseDatasetobs: TStringField;
    NfseDatasetdata_cancelamento: TDateTimeField;
    NfseDatasetjustificativa_cancelamento: TStringField;
    NfseDatasetcodigo_interno: TIntegerField;
    NfseDatasetexcluido: TBooleanField;
    NfseDatasetinclusao: TDateTimeField;
    NfseDatasetalteracao: TDateTimeField;
    NfseDatasetexclusao: TDateTimeField;
    cbxexcluido: TDBCheckBox;
    cbxtransmitida: TDBCheckBox;
    cbxconsolidada: TDBCheckBox;
    cbxcancelada: TDBCheckBox;
    cbxerroprovedor: TDBCheckBox;
    btnCopiarChaveAcesso: TButton;
    procedure btCancelClick(Sender: TObject);
    procedure XDataClientNfseGetLoad(Response: TXDataClientResponse);
    procedure NfseDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure btnCopiarChaveAcessoClick(Sender: TObject);
    procedure NfseDatasetAfterOpen(DataSet: TDataSet);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewNfseEdit: TFViewNfseEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewNfseEdit }

procedure TFViewNfseEdit.btnCopiarChaveAcessoClick(Sender: TObject);
begin
  THelperServer.CopiarTextoNotificacao('Chave de acesso copiada com sucesso!', 'Cópia de chave de acesso',
    edchave_acesso.Text);
end;

class function TFViewNfseEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewNfseEdit.InsertEntity;
begin
  NfseDataset.Close;
  NfseDataset.SetJsonData('{}');
  NfseDataset.Open;
  NfseDataset.Insert;
end;

class function TFViewNfseEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewNfseEdit(AForm).FInserting := AInserting;
    TFViewNfseEdit(AForm).FId := AId;
    TFViewNfseEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewNfseEdit(AForm).InsertEntity
    else
      TFViewNfseEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewNfseEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewNfseEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    NfseDataset.Connection.Model.DefaultSchema.FindEntityType(
      NfseDataset.EntitySetName
    )
  );
  XDataClientNfseGet.Get(NfseDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewNfseEdit.XDataClientNfseGetLoad(Response: TXDataClientResponse);
begin
  NfseDataset.Close;
  NfseDataset.SetJsonData(Response.Result);
  NfseDataset.Open;
  
  NfseDataset.Edit;  
end;

procedure TFViewNfseEdit.NfseDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewNfseEdit.NfseDatasetAfterOpen(DataSet: TDataSet);
begin
  if edchave_acesso.Text = '' then
    btnCopiarChaveAcesso.Enabled := False;
end;

procedure TFViewNfseEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewNfseEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.nfse.form.lbid');
  lbnumero := TLabel.Create('view.nfse.form.lbnumero');
  lbnfse_transmitida := TLabel.Create('view.nfse.form.lbnfse_transmitida');
  lbnfse_consolidada := TLabel.Create('view.nfse.form.lbnfse_consolidada');
  lbnfse_cancelada := TLabel.Create('view.nfse.form.lbnfse_cancelada');
  lbchave_acesso := TLabel.Create('view.nfse.form.lbchave_acesso');
  lbdata_emissao := TLabel.Create('view.nfse.form.lbdata_emissao');
  lbprotocolo := TLabel.Create('view.nfse.form.lbprotocolo');
  lbrps_numero := TLabel.Create('view.nfse.form.lbrps_numero');
  lbnumero_lote := TLabel.Create('view.nfse.form.lbnumero_lote');
  lbserie := TLabel.Create('view.nfse.form.lbserie');
  lbdata_competencia := TLabel.Create('view.nfse.form.lbdata_competencia');
  lberro_transmissao := TLabel.Create('view.nfse.form.lberro_transmissao');
  lbnfse_erro_provedor := TLabel.Create('view.nfse.form.lbnfse_erro_provedor');
  lbobs := TLabel.Create('view.nfse.form.lbobs');
  lbdata_cancelamento := TLabel.Create('view.nfse.form.lbdata_cancelamento');
  lbjustificativa_cancelamento := TLabel.Create('view.nfse.form.lbjustificativa_cancelamento');
  lbcodigo_interno := TLabel.Create('view.nfse.form.lbcodigo_interno');
  lbexcluido := TLabel.Create('view.nfse.form.lbexcluido');
  lbinclusao := TLabel.Create('view.nfse.form.lbinclusao');
  lbalteracao := TLabel.Create('view.nfse.form.lbalteracao');
  lbexclusao := TLabel.Create('view.nfse.form.lbexclusao');
  btCancel := TButton.Create('view.nfse.form.btBack');
  edid := TDBEdit.Create('view.nfse.form.edid');
  ednumero := TDBEdit.Create('view.nfse.form.ednumero');
  edchave_acesso := TDBEdit.Create('view.nfse.form.edchave_acesso');
  eddata_emissao := TDBEdit.Create('view.nfse.form.eddata_emissao');
  edprotocolo := TDBEdit.Create('view.nfse.form.edprotocolo');
  edrps_numero := TDBEdit.Create('view.nfse.form.edrps_numero');
  ednumero_lote := TDBEdit.Create('view.nfse.form.ednumero_lote');
  edserie := TDBEdit.Create('view.nfse.form.edserie');
  eddata_competencia := TDBEdit.Create('view.nfse.form.eddata_competencia');
  ederro_transmissao := TDBEdit.Create('view.nfse.form.ederro_transmissao');
  edobs := TDBEdit.Create('view.nfse.form.edobs');
  eddata_cancelamento := TDBEdit.Create('view.nfse.form.eddata_cancelamento');
  edjustificativa_cancelamento := TDBEdit.Create('view.nfse.form.edjustificativa_cancelamento');
  edcodigo_interno := TDBEdit.Create('view.nfse.form.edcodigo_interno');
  edinclusao := TDBEdit.Create('view.nfse.form.edinclusao');
  edalteracao := TDBEdit.Create('view.nfse.form.edalteracao');
  edexclusao := TDBEdit.Create('view.nfse.form.edexclusao');
  cbxexcluido := TDBCheckBox.Create('view.nfse.form.cbxexcluido');
  cbxtransmitida := TDBCheckBox.Create('view.nfse.form.cbxtransmitida');
  cbxconsolidada := TDBCheckBox.Create('view.nfse.form.cbxconsolidada');
  cbxcancelada := TDBCheckBox.Create('view.nfse.form.cbxcancelada');
  cbxerroprovedor := TDBCheckBox.Create('view.nfse.form.cbxerroprovedor');
  btnCopiarChaveAcesso := TButton.Create('btnCopiarChaveAcesso');
  DataSource := TDataSource.Create(Self);
  NfseDataset := TXDataWebDataSet.Create(Self);
  NfseDatasetid := TIntegerField.Create(Self);
  NfseDatasetaliado_id := TIntegerField.Create(Self);
  NfseDatasetdata_base_id := TIntegerField.Create(Self);
  NfseDatasetnumero := TIntegerField.Create(Self);
  NfseDatasetnfse_transmitida := TBooleanField.Create(Self);
  NfseDatasetnfse_consolidada := TBooleanField.Create(Self);
  NfseDatasetnfse_cancelada := TBooleanField.Create(Self);
  NfseDatasetnfse_cod_verificacao := TStringField.Create(Self);
  NfseDatasetchave_acesso := TStringField.Create(Self);
  NfseDatasetdata_emissao := TDateTimeField.Create(Self);
  NfseDatasetprotocolo := TStringField.Create(Self);
  NfseDatasetrps_numero := TIntegerField.Create(Self);
  NfseDatasetnumero_lote := TIntegerField.Create(Self);
  NfseDatasetserie := TStringField.Create(Self);
  NfseDatasetnfse_xml_s3 := TStringField.Create(Self);
  NfseDatasetanexo_sincronizado := TIntegerField.Create(Self);
  NfseDatasetdata_competencia := TDateTimeField.Create(Self);
  NfseDataseterro_transmissao := TStringField.Create(Self);
  NfseDatasetnfse_erro_provedor := TBooleanField.Create(Self);
  NfseDatasetobs := TStringField.Create(Self);
  NfseDatasetdata_cancelamento := TDateTimeField.Create(Self);
  NfseDatasetjustificativa_cancelamento := TStringField.Create(Self);
  NfseDatasetcodigo_interno := TIntegerField.Create(Self);
  NfseDatasetexcluido := TBooleanField.Create(Self);
  NfseDatasetinclusao := TDateTimeField.Create(Self);
  NfseDatasetalteracao := TDateTimeField.Create(Self);
  NfseDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientNfseGet := TXDataWebClient.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbnumero.BeforeLoadDFMValues;
  lbnfse_transmitida.BeforeLoadDFMValues;
  lbnfse_consolidada.BeforeLoadDFMValues;
  lbnfse_cancelada.BeforeLoadDFMValues;
  lbchave_acesso.BeforeLoadDFMValues;
  lbdata_emissao.BeforeLoadDFMValues;
  lbprotocolo.BeforeLoadDFMValues;
  lbrps_numero.BeforeLoadDFMValues;
  lbnumero_lote.BeforeLoadDFMValues;
  lbserie.BeforeLoadDFMValues;
  lbdata_competencia.BeforeLoadDFMValues;
  lberro_transmissao.BeforeLoadDFMValues;
  lbnfse_erro_provedor.BeforeLoadDFMValues;
  lbobs.BeforeLoadDFMValues;
  lbdata_cancelamento.BeforeLoadDFMValues;
  lbjustificativa_cancelamento.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  ednumero.BeforeLoadDFMValues;
  edchave_acesso.BeforeLoadDFMValues;
  eddata_emissao.BeforeLoadDFMValues;
  edprotocolo.BeforeLoadDFMValues;
  edrps_numero.BeforeLoadDFMValues;
  ednumero_lote.BeforeLoadDFMValues;
  edserie.BeforeLoadDFMValues;
  eddata_competencia.BeforeLoadDFMValues;
  ederro_transmissao.BeforeLoadDFMValues;
  edobs.BeforeLoadDFMValues;
  eddata_cancelamento.BeforeLoadDFMValues;
  edjustificativa_cancelamento.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  cbxexcluido.BeforeLoadDFMValues;
  cbxtransmitida.BeforeLoadDFMValues;
  cbxconsolidada.BeforeLoadDFMValues;
  cbxcancelada.BeforeLoadDFMValues;
  cbxerroprovedor.BeforeLoadDFMValues;
  btnCopiarChaveAcesso.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  NfseDataset.BeforeLoadDFMValues;
  NfseDatasetid.BeforeLoadDFMValues;
  NfseDatasetaliado_id.BeforeLoadDFMValues;
  NfseDatasetdata_base_id.BeforeLoadDFMValues;
  NfseDatasetnumero.BeforeLoadDFMValues;
  NfseDatasetnfse_transmitida.BeforeLoadDFMValues;
  NfseDatasetnfse_consolidada.BeforeLoadDFMValues;
  NfseDatasetnfse_cancelada.BeforeLoadDFMValues;
  NfseDatasetnfse_cod_verificacao.BeforeLoadDFMValues;
  NfseDatasetchave_acesso.BeforeLoadDFMValues;
  NfseDatasetdata_emissao.BeforeLoadDFMValues;
  NfseDatasetprotocolo.BeforeLoadDFMValues;
  NfseDatasetrps_numero.BeforeLoadDFMValues;
  NfseDatasetnumero_lote.BeforeLoadDFMValues;
  NfseDatasetserie.BeforeLoadDFMValues;
  NfseDatasetnfse_xml_s3.BeforeLoadDFMValues;
  NfseDatasetanexo_sincronizado.BeforeLoadDFMValues;
  NfseDatasetdata_competencia.BeforeLoadDFMValues;
  NfseDataseterro_transmissao.BeforeLoadDFMValues;
  NfseDatasetnfse_erro_provedor.BeforeLoadDFMValues;
  NfseDatasetobs.BeforeLoadDFMValues;
  NfseDatasetdata_cancelamento.BeforeLoadDFMValues;
  NfseDatasetjustificativa_cancelamento.BeforeLoadDFMValues;
  NfseDatasetcodigo_interno.BeforeLoadDFMValues;
  NfseDatasetexcluido.BeforeLoadDFMValues;
  NfseDatasetinclusao.BeforeLoadDFMValues;
  NfseDatasetalteracao.BeforeLoadDFMValues;
  NfseDatasetexclusao.BeforeLoadDFMValues;
  XDataClientNfseGet.BeforeLoadDFMValues;
  try
    Name := 'FViewNfseEdit';
    Width := 579;
    Height := 410;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 16;
    lbid.Top := 8;
    lbid.Width := 56;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd. Serv.:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbnumero.SetParentComponent(Self);
    lbnumero.Name := 'lbnumero';
    lbnumero.Left := 16;
    lbnumero.Top := 36;
    lbnumero.Width := 41;
    lbnumero.Height := 13;
    lbnumero.Caption := 'N'#250'mero:';
    lbnumero.HeightPercent := 100.000000000000000000;
    lbnumero.WidthPercent := 100.000000000000000000;
    lbnfse_transmitida.SetParentComponent(Self);
    lbnfse_transmitida.Name := 'lbnfse_transmitida';
    lbnfse_transmitida.Left := 16;
    lbnfse_transmitida.Top := 63;
    lbnfse_transmitida.Width := 60;
    lbnfse_transmitida.Height := 13;
    lbnfse_transmitida.Caption := 'Transmitida?';
    lbnfse_transmitida.HeightPercent := 100.000000000000000000;
    lbnfse_transmitida.WidthPercent := 100.000000000000000000;
    lbnfse_consolidada.SetParentComponent(Self);
    lbnfse_consolidada.Name := 'lbnfse_consolidada';
    lbnfse_consolidada.Left := 16;
    lbnfse_consolidada.Top := 90;
    lbnfse_consolidada.Width := 63;
    lbnfse_consolidada.Height := 13;
    lbnfse_consolidada.Caption := 'Consolidada?';
    lbnfse_consolidada.HeightPercent := 100.000000000000000000;
    lbnfse_consolidada.WidthPercent := 100.000000000000000000;
    lbnfse_cancelada.SetParentComponent(Self);
    lbnfse_cancelada.Name := 'lbnfse_cancelada';
    lbnfse_cancelada.Left := 16;
    lbnfse_cancelada.Top := 117;
    lbnfse_cancelada.Width := 55;
    lbnfse_cancelada.Height := 13;
    lbnfse_cancelada.Caption := 'Cancelada?';
    lbnfse_cancelada.HeightPercent := 100.000000000000000000;
    lbnfse_cancelada.WidthPercent := 100.000000000000000000;
    lbchave_acesso.SetParentComponent(Self);
    lbchave_acesso.Name := 'lbchave_acesso';
    lbchave_acesso.Left := 16;
    lbchave_acesso.Top := 147;
    lbchave_acesso.Width := 72;
    lbchave_acesso.Height := 13;
    lbchave_acesso.Caption := 'Chave Acesso:';
    lbchave_acesso.HeightPercent := 100.000000000000000000;
    lbchave_acesso.WidthPercent := 100.000000000000000000;
    lbdata_emissao.SetParentComponent(Self);
    lbdata_emissao.Name := 'lbdata_emissao';
    lbdata_emissao.Left := 16;
    lbdata_emissao.Top := 174;
    lbdata_emissao.Width := 42;
    lbdata_emissao.Height := 13;
    lbdata_emissao.Caption := 'Emiss'#227'o:';
    lbdata_emissao.HeightPercent := 100.000000000000000000;
    lbdata_emissao.WidthPercent := 100.000000000000000000;
    lbprotocolo.SetParentComponent(Self);
    lbprotocolo.Name := 'lbprotocolo';
    lbprotocolo.Left := 16;
    lbprotocolo.Top := 201;
    lbprotocolo.Width := 49;
    lbprotocolo.Height := 13;
    lbprotocolo.Caption := 'Protocolo:';
    lbprotocolo.HeightPercent := 100.000000000000000000;
    lbprotocolo.WidthPercent := 100.000000000000000000;
    lbrps_numero.SetParentComponent(Self);
    lbrps_numero.Name := 'lbrps_numero';
    lbrps_numero.Left := 16;
    lbrps_numero.Top := 228;
    lbrps_numero.Width := 63;
    lbrps_numero.Height := 13;
    lbrps_numero.Caption := 'N'#250'mero RPS:';
    lbrps_numero.HeightPercent := 100.000000000000000000;
    lbrps_numero.WidthPercent := 100.000000000000000000;
    lbnumero_lote.SetParentComponent(Self);
    lbnumero_lote.Name := 'lbnumero_lote';
    lbnumero_lote.Left := 16;
    lbnumero_lote.Top := 255;
    lbnumero_lote.Width := 65;
    lbnumero_lote.Height := 13;
    lbnumero_lote.Caption := 'N'#250'mero Lote:';
    lbnumero_lote.HeightPercent := 100.000000000000000000;
    lbnumero_lote.WidthPercent := 100.000000000000000000;
    lbserie.SetParentComponent(Self);
    lbserie.Name := 'lbserie';
    lbserie.Left := 16;
    lbserie.Top := 282;
    lbserie.Width := 28;
    lbserie.Height := 13;
    lbserie.Caption := 'S'#233'rie:';
    lbserie.HeightPercent := 100.000000000000000000;
    lbserie.WidthPercent := 100.000000000000000000;
    lbdata_competencia.SetParentComponent(Self);
    lbdata_competencia.Name := 'lbdata_competencia';
    lbdata_competencia.Left := 272;
    lbdata_competencia.Top := 9;
    lbdata_competencia.Width := 92;
    lbdata_competencia.Height := 13;
    lbdata_competencia.Caption := 'Data Compet'#234'ncia:';
    lbdata_competencia.HeightPercent := 100.000000000000000000;
    lbdata_competencia.WidthPercent := 100.000000000000000000;
    lberro_transmissao.SetParentComponent(Self);
    lberro_transmissao.Name := 'lberro_transmissao';
    lberro_transmissao.Left := 272;
    lberro_transmissao.Top := 36;
    lberro_transmissao.Width := 86;
    lberro_transmissao.Height := 13;
    lberro_transmissao.Caption := 'Erro Transmiss'#227'o:';
    lberro_transmissao.HeightPercent := 100.000000000000000000;
    lberro_transmissao.WidthPercent := 100.000000000000000000;
    lbnfse_erro_provedor.SetParentComponent(Self);
    lbnfse_erro_provedor.Name := 'lbnfse_erro_provedor';
    lbnfse_erro_provedor.Left := 272;
    lbnfse_erro_provedor.Top := 63;
    lbnfse_erro_provedor.Width := 72;
    lbnfse_erro_provedor.Height := 13;
    lbnfse_erro_provedor.Caption := 'Erro Provedor?';
    lbnfse_erro_provedor.HeightPercent := 100.000000000000000000;
    lbnfse_erro_provedor.WidthPercent := 100.000000000000000000;
    lbobs.SetParentComponent(Self);
    lbobs.Name := 'lbobs';
    lbobs.Left := 272;
    lbobs.Top := 90;
    lbobs.Width := 62;
    lbobs.Height := 13;
    lbobs.Caption := 'Observa'#231#227'o:';
    lbobs.HeightPercent := 100.000000000000000000;
    lbobs.WidthPercent := 100.000000000000000000;
    lbdata_cancelamento.SetParentComponent(Self);
    lbdata_cancelamento.Name := 'lbdata_cancelamento';
    lbdata_cancelamento.Left := 272;
    lbdata_cancelamento.Top := 117;
    lbdata_cancelamento.Width := 98;
    lbdata_cancelamento.Height := 13;
    lbdata_cancelamento.Caption := 'Data Cancelamento:';
    lbdata_cancelamento.HeightPercent := 100.000000000000000000;
    lbdata_cancelamento.WidthPercent := 100.000000000000000000;
    lbjustificativa_cancelamento.SetParentComponent(Self);
    lbjustificativa_cancelamento.Name := 'lbjustificativa_cancelamento';
    lbjustificativa_cancelamento.Left := 272;
    lbjustificativa_cancelamento.Top := 144;
    lbjustificativa_cancelamento.Width := 132;
    lbjustificativa_cancelamento.Height := 13;
    lbjustificativa_cancelamento.Caption := 'Justificativa Cancelamento:';
    lbjustificativa_cancelamento.HeightPercent := 100.000000000000000000;
    lbjustificativa_cancelamento.WidthPercent := 100.000000000000000000;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 272;
    lbcodigo_interno.Top := 171;
    lbcodigo_interno.Width := 51;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'C'#243'd. Ret.:';
    lbcodigo_interno.HeightPercent := 100.000000000000000000;
    lbcodigo_interno.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 272;
    lbexcluido.Top := 198;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 272;
    lbinclusao.Top := 225;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 272;
    lbalteracao.Top := 252;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 272;
    lbexclusao.Top := 279;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 70;
    btCancel.Top := 342;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Voltar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 117;
    edid.Top := 5;
    edid.Width := 120;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    ednumero.SetParentComponent(Self);
    ednumero.Name := 'ednumero';
    ednumero.Left := 117;
    ednumero.Top := 33;
    ednumero.Width := 120;
    ednumero.Height := 21;
    ednumero.Enabled := False;
    ednumero.HeightPercent := 100.000000000000000000;
    ednumero.TabOrder := 9;
    ednumero.Text := 'ednumero';
    ednumero.WidthPercent := 100.000000000000000000;
    ednumero.DataField := 'numero';
    ednumero.DataSource := DataSource;
    edchave_acesso.SetParentComponent(Self);
    edchave_acesso.Name := 'edchave_acesso';
    edchave_acesso.Left := 117;
    edchave_acesso.Top := 144;
    edchave_acesso.Width := 120;
    edchave_acesso.Height := 21;
    edchave_acesso.Enabled := False;
    edchave_acesso.HeightPercent := 100.000000000000000000;
    edchave_acesso.TabOrder := 14;
    edchave_acesso.Text := 'edchave_acesso';
    edchave_acesso.WidthPercent := 100.000000000000000000;
    edchave_acesso.DataField := 'chave_acesso';
    edchave_acesso.DataSource := DataSource;
    eddata_emissao.SetParentComponent(Self);
    eddata_emissao.Name := 'eddata_emissao';
    eddata_emissao.Left := 117;
    eddata_emissao.Top := 171;
    eddata_emissao.Width := 120;
    eddata_emissao.Height := 21;
    eddata_emissao.Enabled := False;
    eddata_emissao.HeightPercent := 100.000000000000000000;
    eddata_emissao.TabOrder := 15;
    eddata_emissao.Text := 'eddata_emissao';
    eddata_emissao.WidthPercent := 100.000000000000000000;
    eddata_emissao.DataField := 'data_emissao';
    eddata_emissao.DataSource := DataSource;
    edprotocolo.SetParentComponent(Self);
    edprotocolo.Name := 'edprotocolo';
    edprotocolo.Left := 117;
    edprotocolo.Top := 198;
    edprotocolo.Width := 120;
    edprotocolo.Height := 21;
    edprotocolo.Enabled := False;
    edprotocolo.HeightPercent := 100.000000000000000000;
    edprotocolo.TabOrder := 16;
    edprotocolo.Text := 'edprotocolo';
    edprotocolo.WidthPercent := 100.000000000000000000;
    edprotocolo.DataField := 'protocolo';
    edprotocolo.DataSource := DataSource;
    edrps_numero.SetParentComponent(Self);
    edrps_numero.Name := 'edrps_numero';
    edrps_numero.Left := 117;
    edrps_numero.Top := 225;
    edrps_numero.Width := 120;
    edrps_numero.Height := 21;
    edrps_numero.Enabled := False;
    edrps_numero.HeightPercent := 100.000000000000000000;
    edrps_numero.TabOrder := 17;
    edrps_numero.Text := 'edrps_numero';
    edrps_numero.WidthPercent := 100.000000000000000000;
    edrps_numero.DataField := 'rps_numero';
    edrps_numero.DataSource := DataSource;
    ednumero_lote.SetParentComponent(Self);
    ednumero_lote.Name := 'ednumero_lote';
    ednumero_lote.Left := 117;
    ednumero_lote.Top := 252;
    ednumero_lote.Width := 120;
    ednumero_lote.Height := 21;
    ednumero_lote.Enabled := False;
    ednumero_lote.HeightPercent := 100.000000000000000000;
    ednumero_lote.TabOrder := 18;
    ednumero_lote.Text := 'ednumero_lote';
    ednumero_lote.WidthPercent := 100.000000000000000000;
    ednumero_lote.DataField := 'numero_lote';
    ednumero_lote.DataSource := DataSource;
    edserie.SetParentComponent(Self);
    edserie.Name := 'edserie';
    edserie.Left := 117;
    edserie.Top := 279;
    edserie.Width := 120;
    edserie.Height := 21;
    edserie.Enabled := False;
    edserie.HeightPercent := 100.000000000000000000;
    edserie.TabOrder := 19;
    edserie.Text := 'edserie';
    edserie.WidthPercent := 100.000000000000000000;
    edserie.DataField := 'serie';
    edserie.DataSource := DataSource;
    eddata_competencia.SetParentComponent(Self);
    eddata_competencia.Name := 'eddata_competencia';
    eddata_competencia.Left := 421;
    eddata_competencia.Top := 6;
    eddata_competencia.Width := 120;
    eddata_competencia.Height := 21;
    eddata_competencia.Enabled := False;
    eddata_competencia.HeightPercent := 100.000000000000000000;
    eddata_competencia.TabOrder := 22;
    eddata_competencia.Text := 'eddata_competencia';
    eddata_competencia.WidthPercent := 100.000000000000000000;
    eddata_competencia.DataField := 'data_competencia';
    eddata_competencia.DataSource := DataSource;
    ederro_transmissao.SetParentComponent(Self);
    ederro_transmissao.Name := 'ederro_transmissao';
    ederro_transmissao.Left := 421;
    ederro_transmissao.Top := 33;
    ederro_transmissao.Width := 120;
    ederro_transmissao.Height := 21;
    ederro_transmissao.Enabled := False;
    ederro_transmissao.HeightPercent := 100.000000000000000000;
    ederro_transmissao.TabOrder := 23;
    ederro_transmissao.Text := 'ederro_transmissao';
    ederro_transmissao.WidthPercent := 100.000000000000000000;
    ederro_transmissao.DataField := 'erro_transmissao';
    ederro_transmissao.DataSource := DataSource;
    edobs.SetParentComponent(Self);
    edobs.Name := 'edobs';
    edobs.Left := 421;
    edobs.Top := 87;
    edobs.Width := 120;
    edobs.Height := 21;
    edobs.Enabled := False;
    edobs.HeightPercent := 100.000000000000000000;
    edobs.TabOrder := 25;
    edobs.Text := 'edobs';
    edobs.WidthPercent := 100.000000000000000000;
    edobs.DataField := 'obs';
    edobs.DataSource := DataSource;
    eddata_cancelamento.SetParentComponent(Self);
    eddata_cancelamento.Name := 'eddata_cancelamento';
    eddata_cancelamento.Left := 421;
    eddata_cancelamento.Top := 114;
    eddata_cancelamento.Width := 120;
    eddata_cancelamento.Height := 21;
    eddata_cancelamento.Enabled := False;
    eddata_cancelamento.HeightPercent := 100.000000000000000000;
    eddata_cancelamento.TabOrder := 26;
    eddata_cancelamento.Text := 'eddata_cancelamento';
    eddata_cancelamento.WidthPercent := 100.000000000000000000;
    eddata_cancelamento.DataField := 'data_cancelamento';
    eddata_cancelamento.DataSource := DataSource;
    edjustificativa_cancelamento.SetParentComponent(Self);
    edjustificativa_cancelamento.Name := 'edjustificativa_cancelamento';
    edjustificativa_cancelamento.Left := 421;
    edjustificativa_cancelamento.Top := 141;
    edjustificativa_cancelamento.Width := 120;
    edjustificativa_cancelamento.Height := 21;
    edjustificativa_cancelamento.Enabled := False;
    edjustificativa_cancelamento.HeightPercent := 100.000000000000000000;
    edjustificativa_cancelamento.TabOrder := 27;
    edjustificativa_cancelamento.Text := 'edjustificativa_cancelamento';
    edjustificativa_cancelamento.WidthPercent := 100.000000000000000000;
    edjustificativa_cancelamento.DataField := 'justificativa_cancelamento';
    edjustificativa_cancelamento.DataSource := DataSource;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 421;
    edcodigo_interno.Top := 168;
    edcodigo_interno.Width := 120;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := False;
    edcodigo_interno.HeightPercent := 100.000000000000000000;
    edcodigo_interno.TabOrder := 28;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.WidthPercent := 100.000000000000000000;
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 421;
    edinclusao.Top := 222;
    edinclusao.Width := 120;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 30;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 421;
    edalteracao.Top := 249;
    edalteracao.Width := 120;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 31;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 421;
    edexclusao.Top := 276;
    edexclusao.Width := 120;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 32;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    cbxexcluido.SetParentComponent(Self);
    cbxexcluido.Name := 'cbxexcluido';
    cbxexcluido.Left := 421;
    cbxexcluido.Top := 194;
    cbxexcluido.Width := 120;
    cbxexcluido.Height := 22;
    cbxexcluido.Caption := 'cbxexcluido';
    cbxexcluido.ChildOrder := 33;
    cbxexcluido.Enabled := False;
    cbxexcluido.HeightPercent := 100.000000000000000000;
    cbxexcluido.WidthPercent := 100.000000000000000000;
    cbxexcluido.DataField := 'excluido';
    cbxexcluido.DataSource := DataSource;
    cbxtransmitida.SetParentComponent(Self);
    cbxtransmitida.Name := 'cbxtransmitida';
    cbxtransmitida.Left := 117;
    cbxtransmitida.Top := 60;
    cbxtransmitida.Width := 120;
    cbxtransmitida.Height := 22;
    cbxtransmitida.Caption := 'cbxtransmitida';
    cbxtransmitida.ChildOrder := 33;
    cbxtransmitida.Enabled := False;
    cbxtransmitida.HeightPercent := 100.000000000000000000;
    cbxtransmitida.WidthPercent := 100.000000000000000000;
    cbxtransmitida.DataField := 'nfse_transmitida';
    cbxtransmitida.DataSource := DataSource;
    cbxconsolidada.SetParentComponent(Self);
    cbxconsolidada.Name := 'cbxconsolidada';
    cbxconsolidada.Left := 117;
    cbxconsolidada.Top := 87;
    cbxconsolidada.Width := 120;
    cbxconsolidada.Height := 22;
    cbxconsolidada.Caption := 'cbxconsolidada';
    cbxconsolidada.ChildOrder := 33;
    cbxconsolidada.Enabled := False;
    cbxconsolidada.HeightPercent := 100.000000000000000000;
    cbxconsolidada.WidthPercent := 100.000000000000000000;
    cbxconsolidada.DataField := 'nfse_consolidada';
    cbxconsolidada.DataSource := DataSource;
    cbxcancelada.SetParentComponent(Self);
    cbxcancelada.Name := 'cbxcancelada';
    cbxcancelada.Left := 117;
    cbxcancelada.Top := 114;
    cbxcancelada.Width := 120;
    cbxcancelada.Height := 22;
    cbxcancelada.Caption := 'cbxcancelada';
    cbxcancelada.ChildOrder := 33;
    cbxcancelada.Enabled := False;
    cbxcancelada.HeightPercent := 100.000000000000000000;
    cbxcancelada.WidthPercent := 100.000000000000000000;
    cbxcancelada.DataField := 'nfse_cancelada';
    cbxcancelada.DataSource := DataSource;
    cbxerroprovedor.SetParentComponent(Self);
    cbxerroprovedor.Name := 'cbxerroprovedor';
    cbxerroprovedor.Left := 421;
    cbxerroprovedor.Top := 59;
    cbxerroprovedor.Width := 120;
    cbxerroprovedor.Height := 22;
    cbxerroprovedor.Caption := 'cbxerroprovedor';
    cbxerroprovedor.ChildOrder := 33;
    cbxerroprovedor.Enabled := False;
    cbxerroprovedor.HeightPercent := 100.000000000000000000;
    cbxerroprovedor.WidthPercent := 100.000000000000000000;
    cbxerroprovedor.DataField := 'nfse_erro_provedor';
    cbxerroprovedor.DataSource := DataSource;
    btnCopiarChaveAcesso.SetParentComponent(Self);
    btnCopiarChaveAcesso.Name := 'btnCopiarChaveAcesso';
    btnCopiarChaveAcesso.Left := 234;
    btnCopiarChaveAcesso.Top := 144;
    btnCopiarChaveAcesso.Width := 30;
    btnCopiarChaveAcesso.Height := 21;
    btnCopiarChaveAcesso.ChildOrder := 22;
    btnCopiarChaveAcesso.HeightPercent := 100.000000000000000000;
    btnCopiarChaveAcesso.WidthPercent := 100.000000000000000000;
    SetEvent(btnCopiarChaveAcesso, Self, 'OnClick', 'btnCopiarChaveAcessoClick');
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := NfseDataset;
    DataSource.Left := 448;
    DataSource.Top := 328;
    NfseDataset.SetParentComponent(Self);
    NfseDataset.Name := 'NfseDataset';
    NfseDataset.AfterApplyUpdates := NfseDatasetAfterApplyUpdates;
    NfseDataset.AfterOpen := NfseDatasetAfterOpen;
    NfseDataset.EntitySetName := 'Nfse';
    NfseDataset.Connection := DMConnection.ApiConnection;
    NfseDataset.Left := 344;
    NfseDataset.Top := 320;
    NfseDatasetid.SetParentComponent(NfseDataset);
    NfseDatasetid.Name := 'NfseDatasetid';
    NfseDatasetid.FieldName := 'id';
    NfseDatasetid.Required := True;
    NfseDatasetaliado_id.SetParentComponent(NfseDataset);
    NfseDatasetaliado_id.Name := 'NfseDatasetaliado_id';
    NfseDatasetaliado_id.FieldName := 'aliado_id';
    NfseDatasetaliado_id.Required := True;
    NfseDatasetdata_base_id.SetParentComponent(NfseDataset);
    NfseDatasetdata_base_id.Name := 'NfseDatasetdata_base_id';
    NfseDatasetdata_base_id.FieldName := 'data_base_id';
    NfseDatasetdata_base_id.Required := True;
    NfseDatasetnumero.SetParentComponent(NfseDataset);
    NfseDatasetnumero.Name := 'NfseDatasetnumero';
    NfseDatasetnumero.FieldName := 'numero';
    NfseDatasetnfse_transmitida.SetParentComponent(NfseDataset);
    NfseDatasetnfse_transmitida.Name := 'NfseDatasetnfse_transmitida';
    NfseDatasetnfse_transmitida.FieldName := 'nfse_transmitida';
    NfseDatasetnfse_consolidada.SetParentComponent(NfseDataset);
    NfseDatasetnfse_consolidada.Name := 'NfseDatasetnfse_consolidada';
    NfseDatasetnfse_consolidada.FieldName := 'nfse_consolidada';
    NfseDatasetnfse_cancelada.SetParentComponent(NfseDataset);
    NfseDatasetnfse_cancelada.Name := 'NfseDatasetnfse_cancelada';
    NfseDatasetnfse_cancelada.FieldName := 'nfse_cancelada';
    NfseDatasetnfse_cod_verificacao.SetParentComponent(NfseDataset);
    NfseDatasetnfse_cod_verificacao.Name := 'NfseDatasetnfse_cod_verificacao';
    NfseDatasetnfse_cod_verificacao.FieldName := 'nfse_cod_verificacao';
    NfseDatasetnfse_cod_verificacao.Size := 255;
    NfseDatasetchave_acesso.SetParentComponent(NfseDataset);
    NfseDatasetchave_acesso.Name := 'NfseDatasetchave_acesso';
    NfseDatasetchave_acesso.FieldName := 'chave_acesso';
    NfseDatasetchave_acesso.Size := 255;
    NfseDatasetdata_emissao.SetParentComponent(NfseDataset);
    NfseDatasetdata_emissao.Name := 'NfseDatasetdata_emissao';
    NfseDatasetdata_emissao.FieldName := 'data_emissao';
    NfseDatasetdata_emissao.DisplayFormat := 'dd/mm/yy';
    NfseDatasetprotocolo.SetParentComponent(NfseDataset);
    NfseDatasetprotocolo.Name := 'NfseDatasetprotocolo';
    NfseDatasetprotocolo.FieldName := 'protocolo';
    NfseDatasetprotocolo.Size := 255;
    NfseDatasetrps_numero.SetParentComponent(NfseDataset);
    NfseDatasetrps_numero.Name := 'NfseDatasetrps_numero';
    NfseDatasetrps_numero.FieldName := 'rps_numero';
    NfseDatasetnumero_lote.SetParentComponent(NfseDataset);
    NfseDatasetnumero_lote.Name := 'NfseDatasetnumero_lote';
    NfseDatasetnumero_lote.FieldName := 'numero_lote';
    NfseDatasetserie.SetParentComponent(NfseDataset);
    NfseDatasetserie.Name := 'NfseDatasetserie';
    NfseDatasetserie.FieldName := 'serie';
    NfseDatasetserie.Size := 255;
    NfseDatasetnfse_xml_s3.SetParentComponent(NfseDataset);
    NfseDatasetnfse_xml_s3.Name := 'NfseDatasetnfse_xml_s3';
    NfseDatasetnfse_xml_s3.FieldName := 'nfse_xml_s3';
    NfseDatasetnfse_xml_s3.Size := 65536;
    NfseDatasetanexo_sincronizado.SetParentComponent(NfseDataset);
    NfseDatasetanexo_sincronizado.Name := 'NfseDatasetanexo_sincronizado';
    NfseDatasetanexo_sincronizado.FieldName := 'anexo_sincronizado';
    NfseDatasetdata_competencia.SetParentComponent(NfseDataset);
    NfseDatasetdata_competencia.Name := 'NfseDatasetdata_competencia';
    NfseDatasetdata_competencia.FieldName := 'data_competencia';
    NfseDatasetdata_competencia.DisplayFormat := 'dd/mm/yy';
    NfseDataseterro_transmissao.SetParentComponent(NfseDataset);
    NfseDataseterro_transmissao.Name := 'NfseDataseterro_transmissao';
    NfseDataseterro_transmissao.FieldName := 'erro_transmissao';
    NfseDataseterro_transmissao.Size := 255;
    NfseDatasetnfse_erro_provedor.SetParentComponent(NfseDataset);
    NfseDatasetnfse_erro_provedor.Name := 'NfseDatasetnfse_erro_provedor';
    NfseDatasetnfse_erro_provedor.FieldName := 'nfse_erro_provedor';
    NfseDatasetobs.SetParentComponent(NfseDataset);
    NfseDatasetobs.Name := 'NfseDatasetobs';
    NfseDatasetobs.FieldName := 'obs';
    NfseDatasetobs.Size := 255;
    NfseDatasetdata_cancelamento.SetParentComponent(NfseDataset);
    NfseDatasetdata_cancelamento.Name := 'NfseDatasetdata_cancelamento';
    NfseDatasetdata_cancelamento.FieldName := 'data_cancelamento';
    NfseDatasetdata_cancelamento.DisplayFormat := 'dd/mm/yy';
    NfseDatasetjustificativa_cancelamento.SetParentComponent(NfseDataset);
    NfseDatasetjustificativa_cancelamento.Name := 'NfseDatasetjustificativa_cancelamento';
    NfseDatasetjustificativa_cancelamento.FieldName := 'justificativa_cancelamento';
    NfseDatasetjustificativa_cancelamento.Size := 255;
    NfseDatasetcodigo_interno.SetParentComponent(NfseDataset);
    NfseDatasetcodigo_interno.Name := 'NfseDatasetcodigo_interno';
    NfseDatasetcodigo_interno.FieldName := 'codigo_interno';
    NfseDatasetcodigo_interno.Required := True;
    NfseDatasetexcluido.SetParentComponent(NfseDataset);
    NfseDatasetexcluido.Name := 'NfseDatasetexcluido';
    NfseDatasetexcluido.FieldName := 'excluido';
    NfseDatasetinclusao.SetParentComponent(NfseDataset);
    NfseDatasetinclusao.Name := 'NfseDatasetinclusao';
    NfseDatasetinclusao.FieldName := 'inclusao';
    NfseDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    NfseDatasetalteracao.SetParentComponent(NfseDataset);
    NfseDatasetalteracao.Name := 'NfseDatasetalteracao';
    NfseDatasetalteracao.FieldName := 'alteracao';
    NfseDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    NfseDatasetexclusao.SetParentComponent(NfseDataset);
    NfseDatasetexclusao.Name := 'NfseDatasetexclusao';
    NfseDatasetexclusao.FieldName := 'exclusao';
    NfseDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    XDataClientNfseGet.SetParentComponent(Self);
    XDataClientNfseGet.Name := 'XDataClientNfseGet';
    XDataClientNfseGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientNfseGet, Self, 'OnLoad', 'XDataClientNfseGetLoad');
    XDataClientNfseGet.Left := 256;
    XDataClientNfseGet.Top := 320;
  finally
    lbid.AfterLoadDFMValues;
    lbnumero.AfterLoadDFMValues;
    lbnfse_transmitida.AfterLoadDFMValues;
    lbnfse_consolidada.AfterLoadDFMValues;
    lbnfse_cancelada.AfterLoadDFMValues;
    lbchave_acesso.AfterLoadDFMValues;
    lbdata_emissao.AfterLoadDFMValues;
    lbprotocolo.AfterLoadDFMValues;
    lbrps_numero.AfterLoadDFMValues;
    lbnumero_lote.AfterLoadDFMValues;
    lbserie.AfterLoadDFMValues;
    lbdata_competencia.AfterLoadDFMValues;
    lberro_transmissao.AfterLoadDFMValues;
    lbnfse_erro_provedor.AfterLoadDFMValues;
    lbobs.AfterLoadDFMValues;
    lbdata_cancelamento.AfterLoadDFMValues;
    lbjustificativa_cancelamento.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    ednumero.AfterLoadDFMValues;
    edchave_acesso.AfterLoadDFMValues;
    eddata_emissao.AfterLoadDFMValues;
    edprotocolo.AfterLoadDFMValues;
    edrps_numero.AfterLoadDFMValues;
    ednumero_lote.AfterLoadDFMValues;
    edserie.AfterLoadDFMValues;
    eddata_competencia.AfterLoadDFMValues;
    ederro_transmissao.AfterLoadDFMValues;
    edobs.AfterLoadDFMValues;
    eddata_cancelamento.AfterLoadDFMValues;
    edjustificativa_cancelamento.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    cbxexcluido.AfterLoadDFMValues;
    cbxtransmitida.AfterLoadDFMValues;
    cbxconsolidada.AfterLoadDFMValues;
    cbxcancelada.AfterLoadDFMValues;
    cbxerroprovedor.AfterLoadDFMValues;
    btnCopiarChaveAcesso.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    NfseDataset.AfterLoadDFMValues;
    NfseDatasetid.AfterLoadDFMValues;
    NfseDatasetaliado_id.AfterLoadDFMValues;
    NfseDatasetdata_base_id.AfterLoadDFMValues;
    NfseDatasetnumero.AfterLoadDFMValues;
    NfseDatasetnfse_transmitida.AfterLoadDFMValues;
    NfseDatasetnfse_consolidada.AfterLoadDFMValues;
    NfseDatasetnfse_cancelada.AfterLoadDFMValues;
    NfseDatasetnfse_cod_verificacao.AfterLoadDFMValues;
    NfseDatasetchave_acesso.AfterLoadDFMValues;
    NfseDatasetdata_emissao.AfterLoadDFMValues;
    NfseDatasetprotocolo.AfterLoadDFMValues;
    NfseDatasetrps_numero.AfterLoadDFMValues;
    NfseDatasetnumero_lote.AfterLoadDFMValues;
    NfseDatasetserie.AfterLoadDFMValues;
    NfseDatasetnfse_xml_s3.AfterLoadDFMValues;
    NfseDatasetanexo_sincronizado.AfterLoadDFMValues;
    NfseDatasetdata_competencia.AfterLoadDFMValues;
    NfseDataseterro_transmissao.AfterLoadDFMValues;
    NfseDatasetnfse_erro_provedor.AfterLoadDFMValues;
    NfseDatasetobs.AfterLoadDFMValues;
    NfseDatasetdata_cancelamento.AfterLoadDFMValues;
    NfseDatasetjustificativa_cancelamento.AfterLoadDFMValues;
    NfseDatasetcodigo_interno.AfterLoadDFMValues;
    NfseDatasetexcluido.AfterLoadDFMValues;
    NfseDatasetinclusao.AfterLoadDFMValues;
    NfseDatasetalteracao.AfterLoadDFMValues;
    NfseDatasetexclusao.AfterLoadDFMValues;
    XDataClientNfseGet.AfterLoadDFMValues;
  end;
end;

end.
